import { render, staticRenderFns } from "./BigImageDialog.vue?vue&type=template&id=7669419a&scoped=true&"
import script from "./BigImageDialog.vue?vue&type=script&lang=js&"
export * from "./BigImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./BigImageDialog.vue?vue&type=style&index=0&id=7669419a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669419a",
  null
  
)

export default component.exports